<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="data.id" cdkFocusInitial>Yes</button>
  <button mat-button (click)="onNoClick()">No</button>
</div>
